import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Checkbox, Radio, Alert } from 'antd';

/**
 * Target picker for "Kopiraj dan".
 *
 * Days here are weekdays of a repeating weekly template, not dated Day 1 /
 * Day 2 entries, so copying is "onto which weekday(s)" rather than a fixed
 * step to the next day — filling Tuesday through Friday from Monday is the
 * common case and would otherwise take four separate copies.
 */
export default function CopyDayModal({
  open,
  sourceLabel,
  targets,
  onCancel,
  onConfirm,
}) {
  const [selected, setSelected] = useState([]);
  // Appending is the default: it can never destroy activities the user has
  // already written into the target day.
  const [mode, setMode] = useState('append');

  useEffect(() => {
    if (open) {
      setSelected([]);
      setMode('append');
    }
  }, [open]);

  const conflicts = targets.filter(
    (target) => selected.includes(target.key) && target.activityCount > 0
  );

  return (
    <Modal
      open={open}
      title={`Kopiraj dan — ${sourceLabel}`}
      okText="Kopiraj"
      cancelText="Odustani"
      okButtonProps={{ disabled: selected.length === 0 }}
      onCancel={onCancel}
      onOk={() => onConfirm(selected, mode)}
    >
      <p style={{ color: '#888', marginTop: 0 }}>
        Izaberite dane u koje želite da kopirate sve aktivnosti dana{' '}
        <strong>{sourceLabel}</strong>. Originalni dan ostaje nepromenjen.
      </p>

      <Checkbox.Group value={selected} onChange={setSelected}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {targets.map((target) => (
            <Checkbox key={target.key} value={target.key}>
              {target.label}{' '}
              <span
                style={{ color: target.activityCount > 0 ? '#c0392b' : '#888' }}
              >
                ({target.activityCount} aktivnosti)
              </span>
            </Checkbox>
          ))}
        </div>
      </Checkbox.Group>

      {conflicts.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <Alert
            type="warning"
            showIcon
            message={`Već ima aktivnosti: ${conflicts
              .map((conflict) => conflict.label)
              .join(', ')}`}
            style={{ marginBottom: 12 }}
          />
          <Radio.Group value={mode} onChange={(e) => setMode(e.target.value)}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Radio value="append">Dodaj na postojeće aktivnosti</Radio>
              <Radio value="replace">Zameni postojeće aktivnosti</Radio>
            </div>
          </Radio.Group>
        </div>
      )}
    </Modal>
  );
}

CopyDayModal.propTypes = {
  open: PropTypes.bool.isRequired,
  sourceLabel: PropTypes.string,
  targets: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      activityCount: PropTypes.number.isRequired,
    })
  ).isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
